import Splide from '@splidejs/splide'
import {initElements} from "../define/shared"

export default function initCoworkersBlock() {
    initElements(".wa-block.coworkers", employees => {
        const employeesSlider = employees.querySelector('.coworkers-slider')

        if (employeesSlider) {
            new Splide(employeesSlider, {
                arrows: true,
                speed: 1000,
                pagination: false,
                perPage: 5,
                breakpoints: {
                    768:{
                        perPage: 3
                    },

                    480:{
                        perPage: 2
                    },

                    360:{
                        perPage: 1
                    }
                }
            }).mount()
        }
    })
}
